import { createContext, useContext, useState, useCallback } from "react";

const DragContext = createContext(null);

export function DragProvider({ children }) {
  const [isDragging, setIsDragging] = useState(false);
  const [dragLine, setDragLine] = useState(null);
  const [startCard, setStartCard] = useState(null);

  const startDrag = useCallback((cardId, side, position) => {
    setIsDragging(true);
    setStartCard({ id: cardId, side });
    setDragLine({ start: position, end: position });
  }, []);

  const updateDragLine = useCallback((position) => {
    setDragLine((prev) => (prev ? { ...prev, end: position } : null));
  }, []);

  const updateDragStart = useCallback((position) => {
    setDragLine((prev) => (prev ? { ...prev, start: position } : null));
  }, []);

  const endDrag = useCallback(() => {
    setIsDragging(false);
    setDragLine(null);
    setStartCard(null);
  }, []);

  const cancelDrag = useCallback(() => {
    setIsDragging(false);
    setDragLine(null);
    setStartCard(null);
  }, []);

  const value = {
    isDragging,
    dragLine,
    startCard,
    startDrag,
    updateDragLine,
    updateDragStart,
    endDrag,
    cancelDrag,
  };

  return <DragContext.Provider value={value}>{children}</DragContext.Provider>;
}

export function useDrag() {
  const context = useContext(DragContext);
  if (!context) {
    throw new Error("useDrag must be used inside <DragProvider>");
  }
  return context;
}
